// emailService.js
 
import emailjs from '@emailjs/browser';

  const sanitize = (value) => {
  if (typeof value === 'string') {
    return value.trim() === '' ? 'N/A' : value;
  }
  if (value === undefined || value === null) {
    return 'N/A';
  }
  return value;
};
 
 
const SERVICE_ID = 'service_azb26ks';
const ADMIN_TEMPLATE_ID = 'template_i4yx3al';
const USER_TEMPLATE_ID = 'template_v3x552b';
 
// SubService template IDs
const SUBSERVICE_ADMIN_TEMPLATE_ID = 'template_0yxv4ra';
const SUBSERVICE_USER_TEMPLATE_ID = 'template_145waea';  
 
const PUBLIC_KEY = 'DyDZ85E9uwzwSyUoD';
 
emailjs.init(PUBLIC_KEY);
 
// Function to get the initial landing URL
let initialLandingUrl = null;
 
const getSourceUrl = () => {
  if (typeof window === "undefined") return "Unknown";
 
  // If we haven't stored the initial URL yet, store it
  if (!initialLandingUrl) {
    initialLandingUrl = window.location.href;
  }
 
  return initialLandingUrl;
};
 
// Function to get IP address
const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to get IP address:", error);
    return "IP address not available";
  }
};
 
// Original functions (keeping your existing ones)
export const sendAdminEmail = async (formData) => {
  const ipAddress = await getIPAddress();
 
  const templateParams = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
alternateNumber: sanitize(formData.alternateNumber),
    category: formData.category,
    streetAddress: formData.streetAddress,
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode,
    fullAddress: `${formData.streetAddress}, ${formData.city}, ${formData.state} ${formData.zipCode}`,
    message: `New legal service request from ${formData.name}`,
    submissionDate: new Date().toLocaleString(),
    ip_address: ipAddress,
    page_source: getSourceUrl(),
   
    // TrustedForm data
    trustedFormCertUrl: formData.xxTrustedFormCertUrl || 'Not available',
    trustedFormPingUrl: formData.xxTrustedFormPingUrl || 'Not available',
    trustedFormToken: formData.xxTrustedFormCertToken || 'Not available',
  };
 
  return emailjs.send(SERVICE_ID, ADMIN_TEMPLATE_ID, templateParams);
};
 
export const sendUserEmail = async (formData) => {
  const ipAddress = await getIPAddress();
 
  const templateParams = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
alternateNumber: sanitize(formData.alternateNumber),
    category: formData.category,
    streetAddress: formData.streetAddress,
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode,
    fullAddress: `${formData.streetAddress}, ${formData.city}, ${formData.state} ${formData.zipCode}`,
    date: new Date().toLocaleDateString(),
    ip_address: ipAddress,
    submissionDate: new Date().toLocaleString(),
    page_source: getSourceUrl(),
   
    // TrustedForm data
    trustedFormCertUrl: formData.xxTrustedFormCertUrl || 'Not available',
    trustedFormPingUrl: formData.xxTrustedFormPingUrl || 'Not available',
    trustedFormToken: formData.xxTrustedFormCertToken || 'Not available',
  };
 
  return emailjs.send(SERVICE_ID, USER_TEMPLATE_ID, templateParams);
};
 
// NEW SubService functions
export const SubServiceSendAdminEmail = async (formData) => {
  const ipAddress = await getIPAddress();
 
  const templateParams = {
    // Handle both desktop and mobile form field names
    firstName: formData.firstName || formData.fist_name || '',
    lastName: formData.lastName || '',
    full_name: `${formData.firstName || formData.fist_name || ''} ${formData.lastName || ''}`.trim(),
    email: formData.email,
    phone: formData.phone,
alternateNumber: sanitize(formData.alternateNumber),
    streetAddress: formData.streetAddress,
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode,
    fullAddress: `${formData.streetAddress || ''}, ${formData.city || ''}, ${formData.state || ''} ${formData.zipCode || ''}`.replace(/^,\s*/, '').trim(),
    message: `New SubService case review request from ${formData.firstName || formData.fist_name || ''} ${formData.lastName || ''}`,
    submissionDate: new Date().toLocaleString(),
    ip_address: ipAddress,
    page_source: getSourceUrl(),
   
    // TrustedForm data
    trustedFormCertUrl: formData.xxTrustedFormCertUrl || 'Not available',
    trustedFormPingUrl: formData.xxTrustedFormPingUrl || 'Not available',
    trustedFormToken: formData.xxTrustedFormCertToken || 'Not available',
   
    // Additional fields for better tracking
    form_type: 'SubService Case Review',
    captcha_verified: 'Yes',
    terms_accepted: formData.termsAccepted ? 'Yes' : 'No',
  };
 
  return emailjs.send(SERVICE_ID, SUBSERVICE_ADMIN_TEMPLATE_ID, templateParams);
};
 
export const SubServiceSendUserEmail = async (formData) => {
  const ipAddress = await getIPAddress();
 
  const templateParams = {
    // Handle both desktop and mobile form field names
    firstName: formData.firstName || formData.firstName || '',
    lastName: formData.lastName || '',
    full_name: `${formData.firstName || formData.firstName || ''} ${formData.lastName || ''}`.trim(),
    email: formData.email,
alternateNumber: sanitize(formData.alternateNumber),

    phone: formData.phone,
    streetAddress: formData.streetAddress,
    city: formData.city,
    state: formData.state,
    zipCode: formData.zipCode,
    fullAddress: `${formData.streetAddress || ''}, ${formData.city || ''}, ${formData.state || ''} ${formData.zipCode || ''}`.replace(/^,\s*/, '').trim(),
    date: new Date().toLocaleDateString(),
    submissionDate: new Date().toLocaleString(),
    ip_address: ipAddress,
    page_source: getSourceUrl(),
   
    // TrustedForm data
    trustedFormCertUrl: formData.xxTrustedFormCertUrl || 'Not available',
    trustedFormPingUrl: formData.xxTrustedFormPingUrl || 'Not available',
    trustedFormToken: formData.xxTrustedFormCertToken || 'Not available',
   
    // Additional fields for personalization
    form_type: 'SubService Case Review',
  };
 
  return emailjs.send(SERVICE_ID, SUBSERVICE_USER_TEMPLATE_ID, templateParams);
};

// ClaimFormInline (Car Accident Claim Form) functions
const CLAIM_FORM_ADMIN_TEMPLATE_ID = 'template_fr4evoh';
const CLAIM_FORM_USER_TEMPLATE_ID = 'template_2yh7dud';

export const ClaimFormSendAdminEmail = async (formData, trustedFormData = {}) => {
  const ipAddress = await getIPAddress();

  const templateParams = {
    name: sanitize(formData.name),
    email: sanitize(formData.email),
    phone: sanitize(formData.phone),
    involved: sanitize(formData.involved),
    injured: sanitize(formData.injured),
    fault: sanitize(formData.fault),
    attorney: sanitize(formData.attorney),
    period: sanitize(formData.period),
    submissionDate: new Date().toLocaleString(),
    ip_address: ipAddress,
    page_source: getSourceUrl(),
    trustedFormCertUrl: trustedFormData.xxTrustedFormCertUrl || trustedFormData.certId || 'Not available',
    trustedFormPingUrl: trustedFormData.xxTrustedFormPingUrl || trustedFormData.pingUrl || 'Not available',
    trustedFormToken: trustedFormData.xxTrustedFormCertToken || trustedFormData.tokenUrl || 'Not available',
  };

  try {
    return await emailjs.send(SERVICE_ID, CLAIM_FORM_ADMIN_TEMPLATE_ID, templateParams);
  } catch (error) {
    console.error('Admin email error details:', {
      status: error.status,
      text: error.text,
      message: error.message,
      response: error.response
    });
    
    // If 422 error, log template params for debugging
    if (error.status === 422) {
      console.error('422 Unprocessable Entity - EmailJS template validation error');
      console.error('Template params sent:', templateParams);
      console.error('Template ID:', CLAIM_FORM_ADMIN_TEMPLATE_ID);
      console.error('Service ID:', SERVICE_ID);
      console.error('Error text:', error.text);
      console.error('Form data received:', formData);
    }
    
    throw error;
  }
};

export const ClaimFormSendUserEmail = async (formData) => {
  // Ensure email is lowercase and trimmed for EmailJS compatibility
  const userEmail = formData.email ? formData.email.trim().toLowerCase() : '';
  
  const templateParams = {
    // Critical: to_email must be lowercase for EmailJS
    to_email: userEmail,
    email: userEmail,
    user_email: userEmail,
    // Name fields
    name: sanitize(formData.name),
    full_name: sanitize(formData.name),
    to_name: sanitize(formData.name),
    // Other fields
    phone: sanitize(formData.phone),
    phone_number: sanitize(formData.phone),
    submissionDate: new Date().toLocaleString(),
    submission_date: new Date().toLocaleDateString('en-US'),
    submission_time: new Date().toLocaleTimeString('en-US'),
    date: new Date().toLocaleDateString('en-US'),
    time: new Date().toLocaleTimeString('en-US'),
    // Email configuration
    from_name: 'Claim4Accidents',
    from_email: 'reachus@fightformesothelioma.com',
    subject: 'Thank You - Claim Review Submission Confirmation',
    reply_to: 'reachus@fightformesothelioma.com'
  };

  try {
    return await emailjs.send(SERVICE_ID, CLAIM_FORM_USER_TEMPLATE_ID, templateParams);
  } catch (error) {
    console.error('User email error details:', {
      status: error.status,
      text: error.text,
      message: error.message,
      response: error.response
    });
    
    // If 412 or 422 error, log template params for debugging
    if (error.status === 412) {
      console.error('412 Precondition Failed - Template validation error');
      console.error('Template params sent:', templateParams);
      console.error('Template ID:', CLAIM_FORM_USER_TEMPLATE_ID);
      console.error('Service ID:', SERVICE_ID);
      console.error('Error text:', error.text);
    }
    
    if (error.status === 422) {
      console.error('422 Unprocessable Entity - EmailJS template validation error');
      console.error('Template params sent:', templateParams);
      console.error('Template ID:', CLAIM_FORM_USER_TEMPLATE_ID);
      console.error('Service ID:', SERVICE_ID);
      console.error('Error text:', error.text);
      console.error('Form data received:', formData);
    }
    
    throw error;
  }
};

// Combined function that sends admin first, then user if admin succeeds
export const ClaimFormSendEmails = async (formData, trustedFormData = {}) => {
  try {
    // First, send admin email
    const adminResponse = await ClaimFormSendAdminEmail(formData, trustedFormData);
    
    // Only if admin email succeeds, send user email
    if (adminResponse && adminResponse.status === 200) {
      const userResponse = await ClaimFormSendUserEmail(formData);
      return { 
        success: true, 
        adminResponse, 
        userResponse 
      };
    } else {
      throw new Error('Admin email failed');
    }
  } catch (error) {
    console.error('Failed to send emails:', error);
    
    // Enhanced error reporting for 422 errors
    if (error.status === 422) {
      const errorMessage = error.text || error.message || '422 Unprocessable Entity - Template validation failed';
      console.error('422 Error Details:', {
        status: error.status,
        text: error.text,
        message: error.message,
        formData: formData,
        trustedFormData: trustedFormData
      });
      
      return { 
        success: false, 
        error: errorMessage,
        statusCode: 422,
        details: {
          status: error.status,
          text: error.text,
          message: error.message
        }
      };
    }
    
    return { 
      success: false, 
      error: error.message || 'Failed to send emails',
      statusCode: error.status || null
    };
  }
}; 